











import { BaseSelect, selectName } from '#components/baseSelect';

import { apiProvider } from '../api';
import { NAME } from '../constants';
import { ZakazkaSelectServerDTO } from '../@types/select.d';

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		nr: Number,
		isClearable: { type: Boolean, default: true },
		isSelectable: { type: Boolean, default: true },
		isViewable: { type: Boolean, default: false },
		openEdit: { type: Function, default: () => {} },
		disabledNr: { type: Boolean, default: undefined },
		visibleDruh: { type: Boolean, default: true },
	},
	data() {
		return {
			storeObject: NAME,
			apiProvider,
			emptyObject: {
				value: null,
				text: null,
				nr: null,
			},
		};
	},
	computed: {
		nrCmp: {
			get() {
				return this.nr || null;
			},
			set(val) {
				this.$emit('update:nr', val);
			},
		},
	},
	methods: {
		dbToBaseMapper(data: ZakazkaSelectServerDTO) {
			return {
				value: data.ZAKAZKA_ID,
				text: data.X_ZAKAZKA_DRUH,
				nr: data.ZAKAZKA_NR,
			};
		},
	},
});
